import {
  automatonSectionBuilders,
  automatonSectionContextMenuConfig,
} from '@components/map/contextMenu/builders/automatonSection';
import { defaultContextMenuConfig, defaultMenuBuilders } from '@components/map/contextMenu/builders/default';
import {
  perimeterCameraBuilders,
  perimeterCameraContextMenuConfig,
} from '@components/map/contextMenu/builders/perimeterCamera';
import { poiBuilders, poiContextMenuConfig } from '@components/map/contextMenu/builders/poi';
import { replayEventBuilders, replayEventContextMenuConfig } from '@components/map/contextMenu/builders/replayEvent';
import {
  getSensorBuilders,
  sensorContextMenuConfig,
  SensorContextMenuContext,
} from '@components/map/contextMenu/builders/sensor';
import { targetBuilders, targetContextMenuConfig } from '@components/map/contextMenu/builders/target';
import { ContextOf, FeatureTypeToContextComponentEnum, MenuBuilder, OptionsOf } from '@components/map/contextMenu/type';

import { MapIdEnum, OperationalMapId } from '@/types/map.types';
import { SensorTypeEnum, SubSensorTypeEnum } from '@/types/sensor/sensors';

type BuilderResolver<T extends FeatureTypeToContextComponentEnum> =
  | MenuBuilder<T>[]
  | ((ctx: ContextOf<T>) => MenuBuilder<T>[]);

type FeatureTypeMenuBuilderResolvers = Partial<{
  [K in FeatureTypeToContextComponentEnum]: BuilderResolver<K>;
}>;

export const featureTypeMenuBuilders: FeatureTypeMenuBuilderResolvers = {
  [FeatureTypeToContextComponentEnum.DEFAULT]: defaultMenuBuilders,
  [FeatureTypeToContextComponentEnum.TARGET]: targetBuilders,
  [FeatureTypeToContextComponentEnum.SENSOR]: (
    ctx: SensorContextMenuContext<SensorTypeEnum | SubSensorTypeEnum | undefined>,
  ) => getSensorBuilders(ctx),
  [FeatureTypeToContextComponentEnum.AUTOMATON_SECTION]: automatonSectionBuilders,
  [FeatureTypeToContextComponentEnum.PERIMETER_CAMERA]: perimeterCameraBuilders,
  [FeatureTypeToContextComponentEnum.POI]: poiBuilders,
  [FeatureTypeToContextComponentEnum.REPLAY_EVENT]: replayEventBuilders,
};

type FeatureTypeMenuOptionsMap = {
  [T in FeatureTypeToContextComponentEnum]: {
    [K in OperationalMapId]: OptionsOf<T>;
  };
};
export const featureTypeOptions: FeatureTypeMenuOptionsMap = {
  [FeatureTypeToContextComponentEnum.TARGET]: {
    [MapIdEnum.LIVE]: targetContextMenuConfig.LIVE,
    [MapIdEnum.LAD]: targetContextMenuConfig.LAD,
    [MapIdEnum.REPLAY]: targetContextMenuConfig.REPLAY,
    [MapIdEnum.STATISTICS]: targetContextMenuConfig.STATISTICS,
  },
  [FeatureTypeToContextComponentEnum.SENSOR]: {
    [MapIdEnum.LIVE]: sensorContextMenuConfig.LIVE,
    [MapIdEnum.LAD]: sensorContextMenuConfig.LAD,
    [MapIdEnum.REPLAY]: sensorContextMenuConfig.REPLAY,
    [MapIdEnum.STATISTICS]: sensorContextMenuConfig.STATISTICS,
  },
  [FeatureTypeToContextComponentEnum.AUTOMATON_SECTION]: {
    [MapIdEnum.LIVE]: automatonSectionContextMenuConfig.LIVE,
    [MapIdEnum.LAD]: automatonSectionContextMenuConfig.LAD,
    [MapIdEnum.REPLAY]: automatonSectionContextMenuConfig.REPLAY,
    [MapIdEnum.STATISTICS]: automatonSectionContextMenuConfig.STATISTICS,
  },
  [FeatureTypeToContextComponentEnum.PERIMETER_CAMERA]: {
    [MapIdEnum.LIVE]: perimeterCameraContextMenuConfig.LIVE,
    [MapIdEnum.LAD]: perimeterCameraContextMenuConfig.LAD,
    [MapIdEnum.REPLAY]: perimeterCameraContextMenuConfig.REPLAY,
    [MapIdEnum.STATISTICS]: perimeterCameraContextMenuConfig.STATISTICS,
  },
  [FeatureTypeToContextComponentEnum.POI]: {
    [MapIdEnum.LIVE]: poiContextMenuConfig.LIVE,
    [MapIdEnum.LAD]: poiContextMenuConfig.LAD,
    [MapIdEnum.REPLAY]: poiContextMenuConfig.REPLAY,
    [MapIdEnum.STATISTICS]: poiContextMenuConfig.STATISTICS,
  },
  [FeatureTypeToContextComponentEnum.REPLAY_EVENT]: {
    [MapIdEnum.LIVE]: replayEventContextMenuConfig.LIVE,
    [MapIdEnum.LAD]: replayEventContextMenuConfig.LAD,
    [MapIdEnum.REPLAY]: replayEventContextMenuConfig.REPLAY,
    [MapIdEnum.STATISTICS]: replayEventContextMenuConfig.STATISTICS,
  },
  [FeatureTypeToContextComponentEnum.DEFAULT]: {
    [MapIdEnum.LIVE]: defaultContextMenuConfig.LIVE,
    [MapIdEnum.LAD]: defaultContextMenuConfig.LAD,
    [MapIdEnum.REPLAY]: defaultContextMenuConfig.REPLAY,
    [MapIdEnum.STATISTICS]: defaultContextMenuConfig.STATISTICS,
  },
};
